import { Download, RefreshCw } from "lucide-react";
import { getAuthToken } from "@/lib/queryClient";

interface VideoResultProps {
  jobId: string;
  previewUrl: string;
  onReset: () => void;
}

export default function VideoResult({ jobId, previewUrl, onReset }: VideoResultProps) {
  const handleDownload = () => {
    const token = getAuthToken();
    const link = document.createElement("a");
    link.href = `/api/video-generator/download/${jobId}${token ? `?token=${token}` : ""}`;
    link.download = `generated_video_${jobId.slice(0, 8)}.mp4`;
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  return (
    <div className="flex flex-col items-center gap-6">
      <div className="text-center">
        <h3 className="text-lg font-semibold text-white">Wideo gotowe!</h3>
        <p className="text-sm text-white/40 mt-1">Podgląd i pobieranie poniżej.</p>
      </div>

      <div className="w-full max-w-md rounded-xl overflow-hidden border border-white/[0.06] bg-black">
        <video
          src={previewUrl}
          controls
          className="w-full max-h-[60vh] object-contain"
          playsInline
          preload="metadata"
        />
      </div>

      <div className="flex items-center gap-3">
        <button
          onClick={handleDownload}
          className="flex items-center gap-2 px-6 py-3 rounded-xl bg-[#ef3e29] hover:bg-[#ef3e29]/80 text-white text-sm font-medium transition"
        >
          <Download size={16} />
          Pobierz MP4
        </button>
        <button
          onClick={onReset}
          className="flex items-center gap-2 px-6 py-3 rounded-xl bg-white/[0.06] hover:bg-white/10 text-white/70 text-sm transition"
        >
          <RefreshCw size={16} />
          Nowe wideo
        </button>
      </div>
    </div>
  );
}
